module.exports = __webpack_public_path__ + "assets/fa24b9e882d3e365207d334c8e8939c6.png";